import type { BufferGeometry, Mesh } from "three";
import { InstancedBufferAttribute } from "three";
import { convertIdArrayToVec4Array } from "./gpuPicking";
import type { ExtendedMesh } from "./threejs/three-extensions";

// Some parts of our rendering use instancing. For example text uses it. In that case, the meshPerAttribute value of the id attribute needs to be larger than the number of instances used.
const MAX_INSTANCES = 10000;

export function setSingleIdAttribute(geometry: BufferGeometry, id: number) {
  // TODO: Instancing should be supported almost everywhere. However, could be good to ensure that this works also when instancing is unsupported?
  geometry.setAttribute("id", new InstancedBufferAttribute(convertIdArrayToVec4Array([id]), 4, false, MAX_INSTANCES));
}

export function setMeshIdAttribute(mesh: Mesh, id: number) {
  (mesh as ExtendedMesh).customAttribute = new InstancedBufferAttribute(
    convertIdArrayToVec4Array([id]),
    4,
    false,
    MAX_INSTANCES,
  );
  (mesh as ExtendedMesh).customAttributeName = "id";
}

/**
 * Clear the id attribute.
 * @param mesh
 */
export function setMeshIdAttributeToZero(mesh: Mesh) {
  (mesh as ExtendedMesh).customAttribute = new InstancedBufferAttribute(
    new Float32Array([0, 0, 0, 0]),
    4,
    false,
    MAX_INSTANCES,
  );
  (mesh as ExtendedMesh).customAttributeName = "id";
}
